/**
 * Loading Component
 */

import { ClipLoader } from 'react-spinners';
import { useTranslation } from 'react-i18next';

const Loading = ({ size = 50 }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center py-12">
      <ClipLoader color="#3B82F6" size={size} />
      <p className="mt-4 text-gray-600">{t('common.loading')}</p>
    </div>
  );
};

export default Loading;

